import { useParams } from "react-router-dom";
import { Analysis, JoeDomains, Schema } from "../../../../@types";
import DynamicAnalysisGrid from "../DynamicAnalysisGrid";
import { useGetDomainData } from "../hooks";

interface Props<T> {
  analysis: Analysis;
  type: T;
  schema: Schema<unknown>;
}

const DomainGrid = <T extends JoeDomains>({
  type,
  schema,
  analysis
}: Props<T>) => {
  const { hash = "" } = useParams();
  const { data } = useGetDomainData(hash, type, analysis);

  return <DynamicAnalysisGrid data={data} schema={schema} />;
};

export default DomainGrid;
